module.exports = __webpack_public_path__ + "static/media/hamburgerIcon.953bbea1.svg";